import React from 'react';
export function TopBar() {
  return <header className="sticky top-0 z-40 w-full border-b border-lavender bg-white/95 backdrop-blur" data-id="element-204" data-mp="3sdwyhb040hms">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-3 px-4 py-3 sm:px-6" data-id="element-205" data-mp="231c4810qzhxu">
        <a href="#top" className="flex items-center" aria-label="Swift Errands home" data-id="element-206" data-mp="1y4c4s8yeldfp">
          <img src="https://cdn.magicpatterns.com/uploads/iyk1wLpUM4cZDTujufWbwN/Swift_Errands_Logo.png" alt="Swift Errands" className="h-9 w-auto sm:h-11" data-id="element-207" data-mp="1t60vq0fxn6yj" />
        </a>
        <a href="#order" className="rounded-full bg-purple px-4 py-2.5 text-xs font-bold text-white shadow-soft transition duration-200 hover:-translate-y-0.5 hover:scale-[1.03] hover:bg-purple-soft hover:shadow-lift active:scale-100 sm:px-6 sm:text-sm" data-id="element-208" data-mp="2lsv624j1cpya">
          Start Your Market Run
        </a>
      </div>
    </header>;
}